import axios from 'axios';
import { saveAs } from 'file-saver';

export const deleteContractDocumentApi = async (customerId, dealOrInstallmentId) => {
  const response = await axios.delete(
    `admin/customer/${customerId}/contractDocument/${dealOrInstallmentId}`
  );
  return response.data;
};

export const createContractDocumentApi = async ({
  customerId,
  dealOrInstallmentId,
  file,
}) => {

  // console.log("createContractDocumentApi", customerId, dealOrInstallmentId, file);

  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(
    `admin/customer/${customerId}/contractDocument/${dealOrInstallmentId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return response.data;
};

export const getContractDocumentApi = async ({
  customerId,
  dealOrInstallmentId,
  fileName,
}) => {
  const response = await axios.get(
    `admin/customer/${customerId}/contractDocument/${dealOrInstallmentId}`,
    {
      responseType: 'blob',
    }
  );
  const contentDisposition = response.headers['content-disposition'];

  // console.log("getContractDocumentApi", customerId, dealOrInstallmentId, fileName, contentDisposition);

  if (!fileName) {
    fileName = 'contract.pdf';
  }
  // if (contentDisposition) {
  //   const fileNameSplit = contentDisposition.split('filename=');
  //   if (fileNameSplit.length === 2)
  //     fileName = fileNameSplit[1];
  // }
  // const blob = new Blob([response.data], { type: response.data.type });
  const file = new File([response.data], fileName, {
    type: response.data.type,
  });
  return file;
};
